
import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonCard,
  IonCardContent,
  IonGrid,
  IonRow,
  IonCol,
  IonIcon,
  IonCardHeader,
  IonButtons,
} from '@ionic/vue';
import {defineComponent, ref, onMounted} from 'vue';
import {logoLinkedin, logoGithub, rocketOutline} from 'ionicons/icons';
import ThemeToggle from '../components/ThemeToggle.vue';

import LocalSkillsChart from '../components/LocalSkillsChart.vue';
import LocalGithubActivity from '../components/LocalGithubActivity.vue';
import LocalTechnologyTimeline from '../components/LocalTechnologyTimeline.vue';
import LocalProjects from '../components/LocalProjects.vue';
import LocalSecurityAudits from '../components/LocalSecurityAudits.vue';
import LocalWorkExperience from '../components/LocalWorkExperience.vue';


function calculateWorkExperienceColumns(): number {
  return window.innerWidth < 992 ? 1 : 2
}

const workExperienceColumns = ref(calculateWorkExperienceColumns());
const workExperienceData = ref(null);

window.addEventListener('resize', () => {
  workExperienceColumns.value = calculateWorkExperienceColumns();
});

async function loadWorkExperienceData() {
  try {
    const response = await fetch('/data/work-experience.json');
    workExperienceData.value = await response.json();
  } catch (error) {
    console.error('Failed to load work experience data:', error);
  }
}

export default defineComponent({
  name: 'Home',
  components: {
    IonContent,
    IonHeader,
    IonPage,
    IonTitle,
    IonToolbar,
    IonCard,
    IonCardContent,
    IonGrid,
    IonRow,
    IonCol,
    IonIcon,
    IonCardHeader,
    IonButtons,
    ThemeToggle,
    LocalSkillsChart,
    LocalGithubActivity,
    LocalTechnologyTimeline,
    LocalProjects,
    LocalSecurityAudits,
    LocalWorkExperience,
  },
  setup() {
    onMounted(() => {
      loadWorkExperienceData();
    });

    return {
      workExperienceColumns,
      workExperienceData,
      logoGithub,
      logoLinkedin,
      rocketOutline,
    }
  }
});
